module.exports = __webpack_public_path__ + "static/media/imagenLightBrown.228acf8b.png";